export const getAccrualReport = (state) => {
  return state.accrualReport;
};

export const getDate = (state) => {
  const { date } = getAccrualReport(state);
  return date;
};

export const getShowCompletedJobs = (state) => {
  const { showCompletedJobs } = getAccrualReport(state);
  return showCompletedJobs;
};

export const getDateApiFormat = (state) => {
  const date = getDate(state);
  return (!date) ? date : date.apiDate;
};
